var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7e7272",
    width: "800px",
    height: "800px",
    viewBox: "-2.4 -2.4 28.80 28.80",
    id: "send-alt",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon multi-color",
    stroke: "#7e7272",
    transform: "rotate(45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#9d1b1b",
    strokeWidth: 0.048
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", {
    style: {
      strokeWidth: 2
    }
  }, "send alt"), /*#__PURE__*/React.createElement("path", {
    id: "secondary-fill",
    d: "M20.35,6l-5.1,14.27a1,1,0,0,1-1.95,0l-2.51-6.52a1,1,0,0,0-.6-.6L5,11.21,19.27,6.12A2,2,0,0,1,20.35,6Z",
    style: {
      fill: "#2ca9bc",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-stroke",
    d: "M20.94,4.39,20.35,6l-5.1,14.27a1,1,0,0,1-1.95,0l-2.51-6.52a1,1,0,0,0-.6-.6L5,11.21,3.67,10.7a1,1,0,0,1,0-1.95L19.61,3.06A1,1,0,0,1,20.94,4.39Zm-10.32,9,3-3",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a4c06252c238da5afdb1d1d58250484b.svg";
export { ForwardRef as ReactComponent };